import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UiNotificationPayload } from "app/models/ui-notification-payload ";
import { AppService } from "app/services/app/app.service";

@Injectable({ providedIn: 'root' })
export class UiNotificationService {

  constructor(
    private appService: AppService,
    private snackBar: MatSnackBar
  ) {}

  handle(payload: UiNotificationPayload): void {
    //const message = this.translate.instant(
    //  payload.i18nKey,
    //  payload.params ?? {}
    //);

    const message = this.appService.getTraduccion(payload.i18nKey, payload.params);

    this.snackBar.open(message, undefined, {
      duration: payload.durationMs ?? 4000,
      panelClass: [`toast-${payload.level}`]
    });
  }
}
